import {Directive, forwardRef, Attribute} from '@angular/core';
import {NG_VALIDATORS, Validator, Validators, AbstractControl, ValidatorFn, ValidationErrors} from '@angular/forms';

@Directive({
    selector: '[validateEqual]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidatorDirective), multi: true }
    ]
})
export class EqualValidatorDirective implements Validator {

    constructor(
        @Attribute('validateEqual')
        public validateEqual: string,
        @Attribute('reverse')
        public reverse: string) {
    }

    validate(control: AbstractControl): ValidationErrors {

        const target = control.root.get(this.validateEqual);

        if (!target) {
            return null;
        }

        const errors = target.value === control.value
                        ? null
                        : { validateEqual: true };

        if (this._isReverse) {
            target.setErrors(errors);
            return null;
        }

        return errors;
    }

    private get _isReverse() {
        return this.reverse === 'true';
    }
}